import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import TopBar from "../TopBar";
import Sidebar from "../Sidebar";
import { getProfile } from "../../store/actions/profileActions";
import PageTransitionProvider from "./PageTransitionProvider";
import ConfirmProvider from "./ConfirmProvider";
import ToastProvider from "./ToastProvider";

/**
 * Persistent app chrome — TopBar + Sidebar stay mounted across route changes
 * so only the main content area swaps (eliminates navigation flicker).
 */
export default function AuthenticatedLayout({ children }) {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile.profile);

  useEffect(() => {
    if (!profile?.first_name) {
      dispatch(getProfile());
    }
  }, [dispatch, profile?.first_name]);

  return (
    <div className="flex flex-col w-full h-screen bg-gray-50 overflow-hidden">
      <div className="flex-shrink-0">
        <TopBar />
      </div>
      <div className="flex min-h-0 min-w-0 w-full flex-1 overflow-hidden">
        <div className="w-0 min-w-0 overflow-visible md:w-auto md:flex-shrink-0 md:h-full">
          <Sidebar />
        </div>
        <div className="flex min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden">
          <ToastProvider>
            <ConfirmProvider>
              <PageTransitionProvider>{children}</PageTransitionProvider>
            </ConfirmProvider>
          </ToastProvider>
        </div>
      </div>
    </div>
  );
}
